export class Sort {
  constructor(difference) {
    this.width = 460
    this.height = 40
    this.top = 0
    this.left = 0
    this.innerElement = "cxSort"
    this.content = "排序"
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.sortItems = []
    this.mainConfig = {}
    this.defaultBtnConfig = {}
    this.sortBtnConfig = {}
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
